exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!./../node_modules/roboto-fontface/css/roboto/roboto-fontface.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!../node_modules/@dian-cmp/estilos/styles-diliforms.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n/* Roboto Font */\n/* Style framework */\n\n.truncate-content {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.backdrop-recibo-pago {\n\tbackground-color: rgba(0,0,0,0.3);\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/GIT/F260V3/ingreso/ng_ingresosimple260/Simple260Ingreso/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/GIT/F260V3/ingreso/ng_ingresosimple260/Simple260Ingreso/node_modules/postcss-loader?{"ident":"postcss"}!D:/GIT/F260V3/ingreso/ng_ingresosimple260/Simple260Ingreso/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles